import React from "react";
import "./FormFieldsStyle.css";

const Table = (props) => {
  const data = props.item && props.item.text && JSON.parse(props.item.text);

  return (
    <div className="table-responsive" id="tableCTA">
      <table className="table table-bordered">
        <tbody>
          <tr>
            {data.headers &&
              data.headers.map((i) => <th style={{ padding: "12px" }}>{i}</th>)}
          </tr>
          {data.data &&
            data.data.map((i) => (
              <tr>
                {i.map((item) => (
                  <td
                    style={{
                      padding: "3px 5px",
                      fontSize: "14px",
                      color: "#444444",
                    }}
                  >
                    {item}
                  </td>
                ))}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
